export const environment = {
  production: false,
  baseUrl: 'https://edifice.elevationreach.com/#',
  baseApiUrl: 'https://api.edificeautomotive.com',
  nestEflowApiUrl: 'https://api.edificeautomotive.com/eflow',
  nestElevationApiUrl: 'https://api.edificeautomotive.com/elevation',
  nestCbrApiUrl: 'https://api.edificeautomotive.com/carbrewer',
  apiHostBg: 'https://egi-api-bg.epiphanex.com',
  socketHost: 'socket1.carbrewer.com:3002',
  apiHostCbr: 'https://api.edificeautomotive.com',
  apiHostHs: 'https://api.edificeautomotive.com',
  apiHost: 'https://api.edificeautomotive.com',
  apiHostMatching: 'https://api.edificeautomotive.com/matching',
  reportsUrl: 'https://reports.edificeautomotive.com',
  hubspotHapiKey: 'ee4e4c27-8686-4c2c-9ffa-4c9ed1ce3495',
  hubspotAccount: 'edifice',
  hapikeys: {
    edifice: 'ee4e4c27-8686-4c2c-9ffa-4c9ed1ce3495',
    vacuworx: '136a5320-2895-4a82-ac0f-41d9b49f6cb9',
    rentawheel: '29957b94-3c84-4457-b329-69cf138f357f',
  },
  authKey: '629ea048ef635147a565f76a116ed3cc',
};
